import { Box, Grid, Group, Image, Paper, Stack, Text, UnstyledButton } from '@mantine/core';
import React from 'react';
import { useAuth } from '../contexts/auth.context';

import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    BarElement,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import { months } from '../utility/util';
import moment from 'moment';


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export default function Home() {
    const { role } = useAuth();
    const vehicles = [
        { title: moment().add(15 * 0, "days").format("YYYY-MM-DD"), rent: 2000, available: 100, support: 300 },
        { title: moment().add(15 * 1, "days").format("YYYY-MM-DD"), rent: 2000, available: 100, support: 300 },
        { title: moment().add(15 * 2, "days").format("YYYY-MM-DD"), rent: 2000, available: 100, support: 300 },
        { title: moment().add(15 * 3, "days").format("YYYY-MM-DD"), rent: 2000, available: 100, support: 300 },
        { title: moment().add(15 * 4, "days").format("YYYY-MM-DD"), rent: 2000, available: 100, support: 300 },
        { title: moment().add(15 * 5, "days").format("YYYY-MM-DD"), rent: 2000, available: 100, support: 300 },
    ]

    return <Grid>
        <Grid.Col span={{ md: 4 }}>
            <Paper style={{ backgroundColor: '#EFEFEF' }} p="xl">
                <Text ta="center" size="50px">2.000</Text>
                <Text ta="center" size="lg" color="gray" mt="md">alugados</Text>
            </Paper>
        </Grid.Col>
        <Grid.Col span={{ md: 4 }}>
            <Paper style={{ backgroundColor: '#EFEFEF' }} p="xl">
                <Text ta="center" size="50px">2.000</Text>
                <Text ta="center" size="lg" color="gray" mt="md">em manutenção</Text>
            </Paper>
        </Grid.Col>
        <Grid.Col span={{ md: 4 }}>
            <Paper style={{ backgroundColor: '#EFEFEF' }} p="xl">
                <Text ta="center" size="50px">2.000</Text>
                <Text ta="center" size="lg" color="gray" mt="md">disponíveis</Text>
            </Paper>
        </Grid.Col>
        <Grid.Col span={{ md: 8 }}>
            <Paper style={{ backgroundColor: '#EFEFEF' }} p="xl">
                <Bar
                    options={{
                        responsive: true,
                        scales: {
                            y:
                            {
                                min: 0,
                                max: 4000,
                            },
                        },
                        plugins: {
                            legend: {
                                position: 'top' as const,
                            },
                            title: {
                                display: true,
                                text: 'Veículos',
                            },
                        },
                    }
                    }
                    data={{
                        labels: vehicles.map(l => l.title),
                        datasets: [
                            {
                                label: 'Disponíveis',
                                data: vehicles.map((l, i) => l.available),
                                borderColor: 'rgb(53, 162, 235)',
                                backgroundColor: 'rgba(53, 162, 235, 0.5)',
                            },
                            {
                                label: 'Alugados',
                                data: vehicles.map((l, i) => l.rent),
                                borderColor: 'rgb(53, 235, 162)',
                                backgroundColor: 'rgba(53, 235, 162, 0.5)',
                            },
                            {
                                label: 'Em manutenção',
                                data: vehicles.map((l, i) => l.support),
                                borderColor: 'rgb(235, 53, 162)',
                                backgroundColor: 'rgba(235, 53, 162, 0.5)',
                            },
                        ],
                    }}
                />
            </Paper>
        </Grid.Col>
        <Grid.Col span={{ md: 4 }}>
            <Paper style={{ backgroundColor: '#EFEFEF' }} p="xl">
                <Stack>
                    {
                        [
                            {},
                            {},
                            {},
                            {},
                            {},
                            {},
                        ].map(history => (
                            <UnstyledButton>
                                <Paper>
                                    <Group>
                                        <Box style={{ flex: 1 }} p="md">
                                            <Text size="sm">Manutenção finalizada</Text>
                                            <Text size="sm" c="gray">ABC-1234</Text>
                                        </Box>
                                        <Box p="md">
                                            <Text ta="right" size="xs" c="gray">{moment().format("DD/MM/YYYY")}</Text>
                                            <Text ta="right" size="xs" c="gray">{moment().format("HH:mm")}</Text>
                                        </Box>
                                    </Group>
                                </Paper>
                            </UnstyledButton>
                        ))
                    }
                </Stack>
            </Paper>
        </Grid.Col>
        <Grid.Col span={{ md: 8 }}>
            <Paper style={{ backgroundColor: '#EFEFEF' }} p="xl">
                <Line
                    options={{
                        responsive: true,
                        plugins: {
                            legend: {
                                position: 'top' as const,
                            },
                            title: {
                                display: true,
                                text: 'Faturamento Anual',
                            },
                        },
                    }}
                    data={{
                        labels: months,
                        datasets: [
                            {
                                label: 'Faturamento',
                                data: months.map((l, i) => (i + 2) * 10000),
                                borderColor: 'rgb(53, 235, 162)',
                                backgroundColor: 'rgba(53, 235, 162, 0.5)',
                            },
                            {
                                label: 'Despesas',
                                data: months.map((l, i) => (i + 2) * 8000),
                                borderColor: 'rgb(235, 53, 162)',
                                backgroundColor: 'rgba(235, 53, 162, 0.5)',
                            },
                        ],
                    }}
                />
            </Paper>
        </Grid.Col>
    </Grid>
}
